export default __webpack_public_path__ + "static/media/statesIcon.fdb57c94.svg";